package games.polyclub.website.frontend.store.pages.logged

import games.polyclub.frontend.lib.messagerenderer.MessageRendererMode
import games.polyclub.frontend.lib.messagerenderer.m
import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.new
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.classSet
import games.polyclub.frontend.lib.react.utils.classes
import games.polyclub.message.*
import games.polyclub.tool.functional.Option
import games.polyclub.tool.functional.retrying
import games.polyclub.website.frontend.store.StoreBff
import games.polyclub.website.frontend.store.appScope
import games.polyclub.website.frontend.store.components.Loading
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.hooks.useAuth
import games.polyclub.website.frontend.store.hooks.useUserPreferences
import games.polyclub.website.frontend.store.layout.userarea.UserAreaLayout
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import kotlinx.coroutines.launch
import react.Props
import react.dom.events.MouseEventHandler
import react.useCallback
import react.useState
import web.html.HTMLButtonElement

val ChangePronounPage = SFC<Props> { _ ->
    val authCtx = useAuth()
    val userPreferencesCtx = useUserPreferences()
    val profile = authCtx.auth!!.profile
    val current = profile.preferredPronoun
    val (pronoun, setPronoun) = useState(current)
    val (submitting, setSubmitting) = useState(false)

    val change = useCallback<MouseEventHandler<HTMLButtonElement>>(userPreferencesCtx.changePreferences, setSubmitting, pronoun) {
        userPreferencesCtx.changePreferences { current ->
            current.copy(pronoun = pronoun)
        }
        setSubmitting(true)
        appScope.launch {
            retrying(exceptionHandler = { it.printStackTrace(); Option.empty() }) {
                StoreBff.changePronoun(pronoun)
                authCtx.reloadProfile().await()
            }
        }.invokeOnCompletion {
            setSubmitting(false)
        }
    }

    UserAreaLayout {
        addBreadcrumb(LoggedSitemap.CHANGE_PRONOUN.pathPart, -"Alterar Pronome")
        Card("card-primary") {
            title = "Alterar Pronome"
            p("lead") {
                +"Nós no PolyClub respeitamos seu pronome, fazemos questão de ajustar cada frase para que utilize o seu pronome correto e nos orgulhamos disso."
            }

            if (submitting) {
                Loading()
                return@Card
            }

            if (current == null) {
                p {
                    +"Você ainda não definiu quais pronomes usamos para referenciar você, por favor ajuste o campo abaixo como você preferir."
                }
            } else if (current.isEmpty) {
                p {
                    +"Você definiu que podemos usar "
                    strong {
                        +"todos os pronomes"
                    }
                    +" ao se referir a você. Se desejar, ajuste o campo abaixo como você preferir."
                }
            } else {
                p {
                    +"Você definiu que devemos usar os pronomes "
                    strong {
                        m(-"${"Ela"/current}/${"Dela"/current}")
                    }
                    +" ao se referir a você. Se desejar, ajuste o campo abaixo como você preferir."
                }
            }
            div("input-group mb-3") {
                select("form-control") {
                    if (pronoun != null) {
                        classSet += "is-valid"
                    }
                    value = when {
                        pronoun == null -> ""
                        pronoun.isEmpty -> "*"
                        else -> pronoun.get().name
                    }
                    onChange = { ev ->
                        setPronoun(when (val value = ev.target.value) {
                            "" -> null
                            "*" -> Option.empty()
                            else -> Option.of(Pronoun.valueOf(value))
                        })
                    }
                    Pronoun.entries.forEach { pronoun ->
                        option {
                            value = pronoun.name
                            m(-"${"Ela"/pronoun}/${"Dela"/pronoun}", MessageRendererMode.RAW)
                        }
                    }
                    option {
                        value = "*"
                        +"Qualquer pronome"
                    }
                }
                div("input-group-append") {
                    div("input-group-text") {
                        span("fas fa-question-circle")
                    }
                }
            }
            div("lead") {
                +"Exemplos:"
            }
            ul {
                li {
                    m(-"$Aqua${"A"/pronoun}$White ${profile.currentName.name} é $Aqua${"uma"/pronoun} ${"sabotadora"/pronoun}$White")
                }
                li {
                    m(-"Clique $Aqua${"nela"/pronoun}$White para $Aqua${"confia-la"/pronoun}$White")
                }
                li {
                    m(-"Este é o corpo $Aqua${"dela"/pronoun}$White, $Aqua${"ela"/pronoun}$White era ${"uma"/pronoun} inocente")
                }
                li {
                    m(-"$Aqua${"Aquela"/pronoun} ${"menina"/pronoun}$White está muito $Aqua${"suspeita"/pronoun}")
                }
            }

            footer = button.new {
                classes = "btn btn-primary"
                onClick = change
                +"Alterar Pronome"
            }
        }
    }
}
